/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../api/common';
import '../../portal/service_error';
import '../api/itemization';
import '../common/create_async_transaction_refund';
import '../common/async_transaction_common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "AsyncTransaction": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failedAtMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.esperanto.api.Merchant",
                    "id": 7,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.model.AsyncTransaction.AsyncTransactionStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.esperanto.model.AsyncTransaction.AsyncTransactionType",
                    "id": 9,
                    "rule": "optional"
                  },
                  "syncFailureType": {
                    "type": ".squareup.portal.service_error.SubmitPortalTransactionErrorType",
                    "id": 22,
                    "rule": "optional"
                  },
                  "failureMessage": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "asyncTransactionRefund": {
                    "type": ".squareup.esperanto.model.AsyncTransactionRefund",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "externalTransactionId": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "partner": {
                    "type": ".squareup.esperanto.model.AsyncTransaction.Partner",
                    "id": 19,
                    "rule": "optional"
                  },
                  "itemizationData": {
                    "type": ".squareup.esperanto.api.ItemizationData",
                    "id": 21,
                    "rule": "optional"
                  },
                  "openBankingDetails": {
                    "type": ".squareup.esperanto.model.AsyncTransactionOpenBankingDetails",
                    "id": 12
                  },
                  "paymentLinkDetails": {
                    "type": ".squareup.esperanto.model.AsyncTransactionPaymentLinkDetails",
                    "id": 17
                  },
                  "lightningDetails": {
                    "type": ".squareup.esperanto.model.AsyncTransactionLightningDetails",
                    "id": 20
                  },
                  "thirdPartyTerminalDetails": {
                    "type": ".squareup.esperanto.model.AsyncTransactionThirdPartyTerminalDetails",
                    "id": 23
                  },
                  "multiBrandDetails": {
                    "type": ".squareup.esperanto.model.AsyncTransactionMultiBrandDetails",
                    "id": 24
                  }
                },
                "nested": {
                  "AsyncTransactionStatus": {
                    "values": {
                      "DO_NOT_USE_STATUS": 0,
                      "CREATED": 1,
                      "PENDING": 2,
                      "COMPLETED": 3,
                      "FAILED": 4
                    }
                  },
                  "AsyncTransactionType": {
                    "values": {
                      "DO_NOT_USE_TYPE": 0,
                      "OPEN_BANKING": 2,
                      "PAYMENT_LINK": 4,
                      "THIRD_PARTY_TERMINAL": 5,
                      "LIGHTNING": 6,
                      "MULTI_BRAND": 7
                    }
                  },
                  "Partner": {
                    "values": {
                      "DO_NOT_USE_PARTNER": 0,
                      "DLOCAL": 1,
                      "MERCADO_PAGO": 2
                    }
                  },
                  "transaction_details": {
                    "oneof": ["openBankingDetails", "paymentLinkDetails", "lightningDetails", "thirdPartyTerminalDetails", "multiBrandDetails"]
                  }
                }
              },
              "AsyncTransactionOpenBankingDetails": {
                "fields": {
                  "partner": {
                    "type": ".squareup.esperanto.model.AsyncTransactionOpenBankingDetails.Partner",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buyerId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "buyerAuthorizedAtMs": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "accountFideliusToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "resourceToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "settlementRiskCategory": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Partner": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "TRUELAYER": 1
                    }
                  }
                }
              },
              "AsyncTransactionRefund": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failedAtMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "refundTransactionId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.model.AsyncTransactionRefund.AsyncTransactionRefundStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "refundOrderId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "refundCreationFailureReason": {
                    "type": ".squareup.esperanto.create_async_transaction_refund.CreateAsyncTransactionRefundError",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AsyncTransactionRefundStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CREATED": 1,
                      "PENDING": 2,
                      "COMPLETED": 3,
                      "FAILED": 4
                    }
                  }
                }
              },
              "AsyncTransactionPaymentLinkDetails": {
                "fields": {
                  "paymentUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AsyncTransactionLightningDetails": {
                "fields": {
                  "paymentUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "amountMilliSats": {
                    "type": "uint64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationTime": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "settleInBitcoin": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "AsyncTransactionThirdPartyTerminalDetails": {
                "fields": {
                  "terminalId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "last4": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": ".squareup.esperanto.common.CardType",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AsyncTransactionMultiBrandDetails": {
                "fields": {
                  "qrCodeAuthUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "availablePaymentMethods": {
                    "type": ".squareup.esperanto.model.AsyncTransactionMultiBrandDetails.MultiBrandPaymentMethod",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "expiresTime": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localizedStatus": {
                    "type": ".squareup.esperanto.model.LocalizedStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "multiBrandPaymentMethod": {
                    "type": ".squareup.esperanto.model.AsyncTransactionMultiBrandDetails.MultiBrandPaymentMethod",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MultiBrandPaymentMethod": {
                    "values": {
                      "DEFAULT_PAYMENT_METHOD_DO_NOT_USE": 0,
                      "PAYPAY": 1,
                      "AU_PAY": 2,
                      "MER_PAY": 3,
                      "RAKUTEN_PAY": 4,
                      "D_BARAI": 5,
                      "ALIPAY_PLUS": 6,
                      "WECHAT_PAY": 7
                    }
                  }
                }
              },
              "LocalizedStatus": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction?.nested?.AsyncTransactionStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction?.nested?.AsyncTransactionType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction?.nested?.Partner && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionOpenBankingDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionOpenBankingDetails?.nested?.Partner && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionRefund && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionRefund?.nested?.AsyncTransactionRefundStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionPaymentLinkDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionLightningDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionThirdPartyTerminalDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionMultiBrandDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionMultiBrandDetails?.nested?.MultiBrandPaymentMethod && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.LocalizedStatus) {
  $root.addJSON(jsonData);
}

/**
 * Asynchronous Transaction.
 *
 * SOURCE AsyncTransaction @ squareup/esperanto/model/async_transaction.proto at 19:1
 */
export const AsyncTransaction = $root.lookupType('squareup.esperanto.model.AsyncTransaction');
fixType(AsyncTransaction);
Builder.createAndAttachToType(AsyncTransaction);
/**
 * SOURCE AsyncTransactionStatus @ squareup/esperanto/model/async_transaction.proto at 41:3
 */
AsyncTransaction.AsyncTransactionStatus = $root.lookupEnum('squareup.esperanto.model.AsyncTransaction.AsyncTransactionStatus').values;
/**
 * SOURCE AsyncTransactionType @ squareup/esperanto/model/async_transaction.proto at 52:3
 */
AsyncTransaction.AsyncTransactionType = $root.lookupEnum('squareup.esperanto.model.AsyncTransaction.AsyncTransactionType').values;
/**
 * SOURCE Partner @ squareup/esperanto/model/async_transaction.proto at 94:3
 */
AsyncTransaction.Partner = $root.lookupEnum('squareup.esperanto.model.AsyncTransaction.Partner').values;
/**
 * Details for an Open Banking transaction.
 * This contains details provided by or generated for our 3rd-party processing partner.
 *
 * SOURCE AsyncTransactionOpenBankingDetails @ squareup/esperanto/model/async_transaction.proto at 115:1
 */
export const AsyncTransactionOpenBankingDetails = $root.lookupType('squareup.esperanto.model.AsyncTransactionOpenBankingDetails');
fixType(AsyncTransactionOpenBankingDetails);
Builder.createAndAttachToType(AsyncTransactionOpenBankingDetails);
/**
 * SOURCE Partner @ squareup/esperanto/model/async_transaction.proto at 116:3
 */
AsyncTransactionOpenBankingDetails.Partner = $root.lookupEnum('squareup.esperanto.model.AsyncTransactionOpenBankingDetails.Partner').values;
/**
 * Refund for an Asynchronous Transaction
 *
 * SOURCE AsyncTransactionRefund @ squareup/esperanto/model/async_transaction.proto at 149:1
 */
export const AsyncTransactionRefund = $root.lookupType('squareup.esperanto.model.AsyncTransactionRefund');
fixType(AsyncTransactionRefund);
Builder.createAndAttachToType(AsyncTransactionRefund);
/**
 * SOURCE AsyncTransactionRefundStatus @ squareup/esperanto/model/async_transaction.proto at 171:3
 */
AsyncTransactionRefund.AsyncTransactionRefundStatus = $root.lookupEnum('squareup.esperanto.model.AsyncTransactionRefund.AsyncTransactionRefundStatus').values;
/**
 * Details for an async transaction processed through a payment link
 *
 * SOURCE AsyncTransactionPaymentLinkDetails @ squareup/esperanto/model/async_transaction.proto at 195:1
 */
export const AsyncTransactionPaymentLinkDetails = $root.lookupType('squareup.esperanto.model.AsyncTransactionPaymentLinkDetails');
fixType(AsyncTransactionPaymentLinkDetails);
Builder.createAndAttachToType(AsyncTransactionPaymentLinkDetails);
/**
 * Details of a lightning payment
 *
 * SOURCE AsyncTransactionLightningDetails @ squareup/esperanto/model/async_transaction.proto at 201:1
 */
export const AsyncTransactionLightningDetails = $root.lookupType('squareup.esperanto.model.AsyncTransactionLightningDetails');
fixType(AsyncTransactionLightningDetails);
Builder.createAndAttachToType(AsyncTransactionLightningDetails);
/**
 * Details of a third party terminal payment
 *
 * SOURCE AsyncTransactionThirdPartyTerminalDetails @ squareup/esperanto/model/async_transaction.proto at 218:1
 */
export const AsyncTransactionThirdPartyTerminalDetails = $root.lookupType('squareup.esperanto.model.AsyncTransactionThirdPartyTerminalDetails');
fixType(AsyncTransactionThirdPartyTerminalDetails);
Builder.createAndAttachToType(AsyncTransactionThirdPartyTerminalDetails);
/**
 * Details of a multi-brand payment
 *
 * SOURCE AsyncTransactionMultiBrandDetails @ squareup/esperanto/model/async_transaction.proto at 236:1
 */
export const AsyncTransactionMultiBrandDetails = $root.lookupType('squareup.esperanto.model.AsyncTransactionMultiBrandDetails');
fixType(AsyncTransactionMultiBrandDetails);
Builder.createAndAttachToType(AsyncTransactionMultiBrandDetails);
/**
 * SOURCE MultiBrandPaymentMethod @ squareup/esperanto/model/async_transaction.proto at 240:3
 */
AsyncTransactionMultiBrandDetails.MultiBrandPaymentMethod = $root.lookupEnum('squareup.esperanto.model.AsyncTransactionMultiBrandDetails.MultiBrandPaymentMethod').values;
/**
 * SOURCE LocalizedStatus @ squareup/esperanto/model/async_transaction.proto at 270:1
 */
export const LocalizedStatus = $root.lookupType('squareup.esperanto.model.LocalizedStatus');
fixType(LocalizedStatus);
Builder.createAndAttachToType(LocalizedStatus);